import type { GetLayoutsFromProductsNormalized } from '@messenger/types'

/**
 * Whether a render paints no page background: a final PDF (never a proof,
 * which keeps its white and gray) of a product whose row sets
 * `transparent_print_background`. Areas the design leaves empty then stay
 * transparent in the PDF, so a UV press printing on a dark substrate lays no
 * white ink there.
 */
export const printsTransparentBackground = (
  layout:
    | Pick<GetLayoutsFromProductsNormalized, 'transparent_print_background'>
    | null
    | undefined,
  proof: boolean,
): boolean => !proof && layout?.transparent_print_background === true
